// extracted by mini-css-extract-plugin
module.exports = {"hover":"_1ZvYX","color":"_3oAT_","blue":"_3RHxL","svg-start":"_1z437","purple":"_1k8eb","red":"CvUVp","green":"_1rIYb"};